import { saveCampaign } from '@bingads-webui-campaign-react/unified-app-shared';
import { getDefaultCampaignData } from './default-data';

export const createDefaultCampaign = ({
  i18n,
  serverContext,
  scenarioContext,
  AppSetting,
  flow,
}) => {
  const permissions = serverContext.Permissions || {};

  const initialCampaignViewModel = {
    data: getDefaultCampaignData({
      i18n,
      serverContext,
      cnMarketAccount: permissions.IsDomesticSimplifiedChineseEnabled,
      AppSetting,
      flow,
    }),
  };

  return saveCampaign({
    campaign: initialCampaignViewModel,
  }, {
    scenario: scenarioContext.name,
    i18n,
    activityLogger: scenarioContext.createActivity('saveDefaultCampaign'),
  });
};
